import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Text, InlineStack, Link, Tooltip, BlockStack } from '@shopify/polaris';
import helpers from 'helpers/index';
import dateandtime from 'date-and-time';
import { useCurrentTicketMoving } from 'context/CurrentTicketMovingContext';
import { TypedTicket, useMutateGetTickets } from 'queries/ticket.query';

export default function BottomBarMovingTicket() {
  const { currentTicketMoving, clearCurrentTicketMoving } = useCurrentTicketMoving();

  const timer = useRef(null);

  const [showQuickBook, setShowQuickBook] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [expiresAt, setExpiresAt] = useState<number | null>(null);
  const previousTicketRef = useRef<string[] | null>(null);

  const { mutateAsync: getTicketsData } = useMutateGetTickets();

  // Data lấy từ URL
  const searchObject = new URLSearchParams(window.location.search);
  const quickbook_journey_id = searchObject.get('journey_id');

  const clearLocalMovingData = useCallback(() => {
    setShowQuickBook(false);
    setCountdown(0);
    setExpiresAt(null);
    previousTicketRef.current = null;
    clearInterval(timer.current);
  }, []);

  useEffect(() => {
    if (!quickbook_journey_id) {
      clearLocalMovingData();
      clearCurrentTicketMoving();
    }
  }, [quickbook_journey_id]);

  // Theo dõi currentTicketMoving
  useEffect(() => {
    if (currentTicketMoving && currentTicketMoving.length > 0) {
      const prev = previousTicketRef.current;

      if (!prev || JSON.stringify(currentTicketMoving) !== JSON.stringify(prev)) {
        setShowQuickBook(true);
        setExpiresAt(Date.now() + 45000); // 45s từ bây giờ
        previousTicketRef.current = currentTicketMoving;
      }
    } else {
      clearLocalMovingData();
    }
  }, [currentTicketMoving]);

  // Đếm ngược theo expiresAt
  useEffect(() => {
    if (expiresAt == null) return;

    setCountdown(Math.max(0, Math.ceil((expiresAt - Date.now()) / 1000)));

    timer.current = setInterval(() => {
      const remaining = Math.ceil((expiresAt - Date.now()) / 1000);
      if (remaining <= 0) {
        clearLocalMovingData();
        clearCurrentTicketMoving();
      } else {
        setCountdown(remaining);
      }
    }, 1000);

    return () => clearInterval(timer.current);
  }, [expiresAt]);

  /** Lấy data ra .... */
  const [currentTicketMovingData, setCurrentTicketMovingData] = useState<TypedTicket[]>([]);
  const takeDataCallback = useCallback(async () => {
    try {
      let fetchData = await getTicketsData({
        ticket_id: (currentTicketMoving || []).join(','),
      });
      setCurrentTicketMovingData(fetchData);
    } catch (e) {
      console.error(e);
    }
  }, [currentTicketMoving, getTicketsData]);

  /** Lấy data */
  useEffect(() => {
    if (!helpers.isEmpty(currentTicketMoving)) takeDataCallback();
  }, [currentTicketMoving, takeDataCallback]);

  return (
    <div className={`bottom-bar ${showQuickBook ? '' : 'hidden'}`}>
      <div
        className="bottom-bar-progress"
        style={{
          width: `${(countdown / 30) * 100}%`,
          transition: 'width 1s linear',
        }}
      ></div>

      <div className="bottom-bar-body">
        <div className="bottom-bar-wrap">
          <div className="left-section">
            {currentTicketMovingData?.map((ticket, index) => {
              return (
                <div key={index} className="bottom_bar_element" id={`moving_ticket_bottom_data_${index}`}>
                  <InlineStack gap="400">
                    <Text as="h3" variant="headingLg">
                      {dateandtime.format(new Date(Number(ticket?.orders?.departure_date)), 'HH:mm', true)}
                    </Text>
                    <BlockStack>
                      <Text as="p" fontWeight="bold">
                        {ticket?.orders?.customer_data?.display_name}
                      </Text>
                      <div>{helpers.trimContentString(ticket?.orders?.pickup_address, 20)}</div>
                    </BlockStack>
                  </InlineStack>
                </div>
              );
            })}
          </div>
          <div className="right-section hide-on-mobile">
            <Tooltip content="Bấm để hủy ngay hoặc nút ESC">
              <Link
                removeUnderline
                onClick={() => {
                  clearLocalMovingData();
                  clearCurrentTicketMoving();
                }}
              >
                Hủy <span>{countdown > 0 && <strong>{countdown}</strong>}</span>
              </Link>
            </Tooltip>
          </div>
        </div>
      </div>
    </div>
  );
}

